import { farsi_number } from "./farsi";

export default function agoCalculator(date: number | null | boolean): string | boolean {
    if (date == null || date === 0) {
        return 'آنلاین نشده'
    }

    if (date === false || date === true) {
        return false
    }

    // date can be php's timestamp
    if (date < 10000000000) {
        date = date * 1000
    }

    const now = Date.now();
    const diff = now - (date as number);
    if (diff < 0) return 'زمان نامعتبر';
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);
    if (seconds < 60) return 'چند ثانیه پیش';
    if (minutes < 60) return `${farsi_number(minutes)} دقیقه پیش`;
    if (hours < 24) return `${farsi_number(hours)} ساعت قبل`;
    if (days < 7) return `${farsi_number(days)} روز پیش`;
    if (weeks < 5) return `${farsi_number(weeks)} هفته پیش`;
    if (months < 12) return `${farsi_number(months)} ماه پیش`;
    return `${farsi_number(years)} سال پیش`;
}